<template>
  <div id="download">
    <b-container class="mt-3">
      <b-row>
        <b-col sm="8">
          <info-main-card :game_info="game_info" />
        </b-col>
        <b-col sm="4">
          <KeymapsCard :game_info="game_info" />
          <CheatsCard :game_info="game_info" />
          <LinksCard :game_info="game_info" />
          <FeedbackCard />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import gameDataJson from "@/utils/info/gameDataJson";
import game_info_mixin from "@/mixins/game_info_mixin";
import InfoMainCard from "./components/InfoMainCard.vue";

import {
  KeymapsCard,
  CheatsCard,
  LinksCard,
  FeedbackCard
} from "@/components/Sidebar"

export default {
  name: "info",
  mixins: [game_info_mixin],
  components: {
    KeymapsCard,
    CheatsCard,
    LinksCard,
    FeedbackCard,
    InfoMainCard,
  },
  metaInfo() {
    return {
      title: `${this.name}游戏信息`,
      meta: [
        {
          name: "description",
          content: `${this.name}的信息集合`,
        },
        {
          name: "keywords",
          content: `${this.name}, 在线, DOS, 游戏, 在线DOS游戏, 百科, 信息`,
        },
        {
          property: "og:title",
          content: `${this.name}游戏信息 - 在线 DOS 游戏`,
        },
        {
          property: "og:url",
          content: this.info_web_url,
        },
        {
          property: "og:description",
          content: `${this.name}的信息集合`,
        },
      ],
      link: [{ rel: "canonical", href: this.info_web_url }],
      script: [
        {
          type: "application/ld+json",
          json: [
            this.structured_data,
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "游戏列表",
                  item: "https://dos.zczc.cz/games/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: this.name,
                  item: this.game_web_url,
                },
                {
                  "@type": "ListItem",
                  position: 3,
                  name: "信息",
                  item: this.info_web_url,
                },
              ],
            },
          ],
        },
      ],
    };
  },
  beforeMount() {
    if (!(this.$route.params.identifier in gameDataJson)) {
      this.$router.replace({ name: "error" });
    }
  },
  computed: {
    game_info() {
      return gameDataJson[this.$route.params.identifier];
    },
  },
};
</script>
